var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoChatAddAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12 2.86957c-5.0426 0-9.13043 4.08783-9.13043 9.13043s4.08783 9.1304 9.13043 9.1304 9.1304-4.0878 9.1304-9.1304-4.0878-9.13043-9.1304-9.13043zm-10 9.13043c0-5.52285 4.47715-10 10-10 5.5228 0 10 4.47715 10 10 0 5.5228-4.4772 10-10 10-5.52285 0-10-4.4772-10-10zm10-5.65217c.2401 0 .4348.19465.4348.43478v4.78259h4.7826c.2401 0 .4348.1947.4348.4348s-.1947.4348-.4348.4348h-4.7826v4.7826c0 .2401-.1947.4348-.4348.4348s-.4348-.1947-.4348-.4348v-4.7826h-4.78259c-.24013 0-.43478-.1947-.43478-.4348s.19465-.4348.43478-.4348h4.78259v-4.78259c0-.24013.1947-.43478.4348-.43478z",
    fill: "#17a680",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChatAddAttachment);
export default __webpack_public_path__ + "static/media/ico_chat_add_attachment.abafea1a8b33abfce3d492a61d900bbe.svg";
export { ForwardRef as ReactComponent };